/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MessageNew_lists$ref = any;
export type MessageNewQueryVariables = {||};
export type MessageNewQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: MessageNew_lists$ref
  |}
|};
export type MessageNewQuery = {|
  variables: MessageNewQueryVariables,
  response: MessageNewQueryResponse,
|};
*/


/*
query MessageNewQuery {
  lists {
    ...MessageNew_lists
    id
  }
}

fragment MessageNew_lists on Lists {
  id
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageNew_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MessageNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MessageNewQuery",
    "operationKind": "query",
    "text": "query MessageNewQuery {\n  lists {\n    ...MessageNew_lists\n    id\n  }\n}\n\nfragment MessageNew_lists on Lists {\n  id\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '337bb1aa5c00a206f1670b6100bc3c37';

module.exports = node;
